import { ChangeDetectionStrategy, ChangeDetectorRef, Component, forwardRef, Input,  } from '@angular/core';
import { ControlContainer, NG_VALUE_ACCESSOR } from '@angular/forms';
import { BaseFpxControlComponent } from '@fpx/core';

@Component({
  selector: 'fpx-switch',
  templateUrl: './fpx-switch.component.html',
  styleUrls: ['./fpx-switch.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => FpxSwitchComponent),
      multi: true
    }
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})

export class FpxSwitchComponent extends BaseFpxControlComponent {
 @Input() labelPosition: "after" | "before" = "before";


  constructor(controlContainer: ControlContainer, private _changeDetectorRef: ChangeDetectorRef) {
    super(controlContainer,_changeDetectorRef );
  }
 
  protected doPreInit(): void {
    
  }


}
